import { React, useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Stock } from "../components/Stock";
import { config } from "../Constants";

const URL = config.url;
export const SkuPage = () => {
    const [stock, setStock] = useState({});
    const { sku } = useParams();
    
    const fetchStocks = useCallback(async () => {
        try {
            const response = await fetch(`${URL}/api/v1/stocks/sku/${sku}`);
            const apiResponse = await response.json();
            const stockData = apiResponse.data || {};
            setStock(prevStock => {
                if (JSON.stringify(prevStock) !== JSON.stringify(stockData)) {
                    return stockData;
                }
                return prevStock;
            });
        } catch (error) {
            console.error("Error fetching stock data:", error);
        }
    }, [sku]);

    useEffect(() => {
        fetchStocks();
        const interval = setInterval(fetchStocks, 5000);
        return () => clearInterval(interval);
    }, [fetchStocks]);

    return (
        <div>
            <Stock stock={stock} key={sku} />
        </div>
    );
};
